export default (node) => {
  const fileInput = node.querySelector('#spf-file-upload');
  const fileNameDisplay = node.querySelector('#spf-file-name');
  const fileError = node.querySelector('#spf-file-error');
  const noFileSelectedText = node.dataset.noFileSelected || 'No file selected';
  const formId = node.dataset.formId;
  const messageSuccess = node.querySelector('[data-message-success]');
  const messageError = node.querySelector('[data-message-error]');
  const formElement = node.querySelector('[data-form-element]');
  const phoneInput = node.querySelector('input[name="Phone"]');

  function validateFile() {
    if (!fileInput || !fileError) return true;
    if (!fileInput.files.length) {
      fileError.classList.remove('hidden');
      fileInput.focus();
      return false;
    }
    fileError.classList.add('hidden');
    return true;
  }

  function showMessage(el, durationMs = 5000) {
    if (!el) return;
    el.classList.remove('hidden');
    setTimeout(() => el.classList.add('hidden'), durationMs);
  }

  const submitForm = async (e) => {
    e.preventDefault();

    if (!validateFile()) return;

    const fd = new FormData();
    new FormData(formElement).forEach((v, k) => fd.append(k, v));
    if (fileInput && fileInput.files.length) {
      fd.set('attachment', fileInput.files[0], fileInput.files[0].name);
    }

    try {
      const response = await fetch(`https://formspree.io/f/${formId}`, {
        method: 'POST',
        body: fd,
        headers: { Accept: 'application/json' },
      });

      if (response.ok) {
        showMessage(messageSuccess);
        formElement.reset();
        if (fileNameDisplay) fileNameDisplay.textContent = noFileSelectedText;
      } else {
        const { errors } = await response.json();
        console.error('Form submission errors:', errors);
        showMessage(messageError);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      showMessage(messageError);
    }
  };

  const init = () => {
    if (fileInput && fileNameDisplay) {
      fileInput.addEventListener('change', () => {
        fileNameDisplay.textContent = fileInput.files.length
          ? fileInput.files[0].name
          : noFileSelectedText;
        if (fileError) fileError.classList.add('hidden');
      });
    }

    if (phoneInput) {
      phoneInput.addEventListener('input', () => {
        phoneInput.value = phoneInput.value.replace(/[^0-9]/g, '');
      });
    }

    // Single handler for all submission paths (button click and Enter key).
    if (formElement) {
      formElement.addEventListener('submit', submitForm);
    }
  };

  init();
};
